module.exports = __webpack_public_path__ + "static/13-32f3883586bf1bb9b6bd922607f29cad.png";